import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;

async function getUserInfo() {
  try {
    const userInfo = await axios
      .get(`${backend}/userInfo`)
      .then((data) => {
        return {state:true, userInfo: data.data.data}
      })
      .catch((err) => {
        if(err.response.status === 401) {
            return {state:false, userInfo: null}
        }
        return err
      })
      // console.log(userInfo)
      return userInfo
  } catch (err) {
    return err
  }
}

export default getUserInfo;
